<template>
  <!-- 零售-核销取货 -->
  <div class="wrapper pb-2x flex-start flex-col">
    <panel-head :close="false" title="门票查询"></panel-head>
    <div
      class="container mt-2x flex-grow"
      v-permission="'appRetailPickTicketTicketinquiry'"
    >
      <KeyboardPro @ok="ok" v-model="numbers">
        <template v-slot:input="{ confirm }">
          <a-input
            size="large"
            allow-clear
            v-model="numbers"
            placeholder="订单号/取票手机号/票号/卡或腕带号"
            @pressEnter="confirm()"
          >
            <a-icon
              class="primary"
              slot="prefix"
              type="search"
              style="font-size:24px"
            />
            <a-icon
              class="primary"
              slot="suffix"
              type="scan"
              style="font-size: 24px"
            />
          </a-input>
        </template>
      </KeyboardPro>
    </div>
  </div>
</template>

<script>
import PanelHead from "../../../components/common/PanelHead.vue";
import KeyboardPro from "../../../components/common/KeyboardPro.vue";
import { orderVerifyclaimgoods } from "../../../api/search";

export default {
  components: { PanelHead, KeyboardPro },
  name: "PickTicketSearch",
  data() {
    return {
      numbers: ""
    };
  },
  created() {
    //先调用方法把扫码类型改成2，再监听硬件扫码方法scanCode
    try {
      window.test.optScan("2");
      window.scanCode = this.scanCode;
    } catch (error) {
      console.log(error);
    }
  },

  beforeDestroy() {
    try {
      window.test.optScan("0");
    } catch (error) {
      console.log(error);
    }
    window.scanCode = null;
  },

  methods: {
    scanCode(res) {
      this.numbers = res;
      this.ok();
    },
    ok() {
      if (!this.numbers) {
        this.$message.warning("请先输入订单号/取票手机号/票号/卡或腕带号");
        return;
      }
      orderVerifyclaimgoods({
        keyword: this.numbers
      })
        .then(res => {
          if (res.length > 0) {
            this.$router.push({
              path: "/retail/take/pickUp",
              query: {
                numbers: this.numbers
              }
            });
            sessionStorage.setItem("pickList", JSON.stringify(res));
          } else {
            this.$message.warning("查无可取货记录");
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  padding-top: 60px;
}
</style>
